var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEliminarRojo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4.3EliminarRojo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.7Reservaciones",
    transform: "translate(-1115.000000, -633.000000)",
    stroke: "#D14343",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(735.500000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 404.272078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(277.500000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.3EliminarRojo",
    transform: "translate(103.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 2,
    x2: 0,
    y2: 2,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 1,
    x2: 5,
    y2: 1,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,6 L1,16 C1,16.6666667 1.33333333,17 2,17 C2.66666667,17 6,17 12,17 C12.6666667,17 13,16.6666667 13,16 C13,15.3333333 13,12 13,6",
    id: "Path-8"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminarRojo);
export default __webpack_public_path__ + "static/media/EliminarRojo.f0940a774465f6e7ec8e26dcfc0c7c4c.svg";
export { ForwardRef as ReactComponent };